import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useNavigate } from "react-router-dom";

export default function PrivatePopup({ indcat }) {
  const [industry, setindustry] = useState("");
  const [active, setActive] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();

  const navigatetofilerhire = (cat, subcat) => {
    const data = {
      industry_id: industry?.id,
      industry_name: industry?.title,
      category_id: cat?.id,
      category_name: cat?.title,
      subcategory_id: subcat?.id,
      subcategory_name: subcat?.title,
    };
    navigate(`/${lan}/filterandhirexperts`, { state: { indcatsub: data } });
  };

  return (
    <>
      <div className="pop-overlay"></div>
      <div className="popup-header">
        {Array.isArray(indcat) && (
          <Swiper
            spaceBetween={10}
            slidesPerView={6}
            onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => console.log(swiper)}
            modules={[]}
            breakpoints={{
              320: {
                slidesPerView: 2.5,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 25,
              },
              1024: {
                slidesPerView: 6,
                spaceBetween: 30,
              },
            }}
          >
            {indcat.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className="dropdown-head "
                  onMouseEnter={() => {
                    setindustry(item);
                    setActive(true);
                  }}
                  onMouseLeave={() => {
                    setActive(false);
                  }}
                >
                  <button className="btn">{item?.title}</button>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
      <div
        className={`dropdown-menu-link ${active ? "active" : ""}`}
        onMouseEnter={() => {
          setActive(true);
        }}
        onMouseLeave={() => {
          setActive(false);
        }}
      >
        <div className="row tabmenu-row">
          {Array.isArray(industry?.category) &&
            industry?.category.map((cat, catindex) => (
              <div className="col-md-3" key={catindex}>
                <div className="tab-menu">
                  <div>
                    <h6>{cat?.title}</h6>
                    {Array.isArray(cat?.subcategory) &&
                      cat?.subcategory.map((subcat, subcatindex) => (
                        <div key={subcatindex}>
                          <a onClick={() => navigatetofilerhire(cat, subcat)}>
                            {subcat?.title}
                          </a>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
